import { FC } from 'react'
import { useSelector } from 'react-redux'

import { Nullable } from 'clickNgo/models/utils'
import { selectPublishingMode } from 'core/store/selectors/selectPublishingMode'
import { FieldLabel } from 'partner360/components/fieldLabel/FieldLabel'

import { RetailerStoresEditMode } from './components/retailerStoresEditMode/RetailerStoresEditMode'
import { RetailerStoresReadMode } from './components/retailerStoresReadMode/RetailerStoresReadMode'
import { TRANSLATION_KEYS } from './translations'

import styles from './RetailerStores.module.scss'

interface IRetailerStoresProps {
  storesTotal: Nullable<number>
  storesPSHW: Nullable<number>
  storesPRHW: Nullable<number>
}

export const RetailerStores: FC<IRetailerStoresProps> = ({
  storesTotal,
  storesPSHW,
  storesPRHW,
}) => {
  const isEditMode = useSelector(selectPublishingMode)

  return (
    <div className={styles.root}>
      <FieldLabel labelTranslation={TRANSLATION_KEYS.fieldLabel} />
      {!isEditMode && (
        <RetailerStoresReadMode
          storesTotal={storesTotal}
          storesPSHW={storesPSHW}
          storesPRHW={storesPRHW}
        />
      )}
      {isEditMode && (
        <RetailerStoresEditMode
          storesTotal={storesTotal}
          storesPSHW={storesPSHW}
          storesPRHW={storesPRHW}
        />
      )}
    </div>
  )
}
